
export default function Rickenbacker() {
  return (
    <section className="bg-gradient-to-b from-stone-100 to-stone-200 py-24 px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 gap-16 items-center">
        {/* Left - Content */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full"></div>
            <span className="text-teal-600 text-sm font-bold tracking-wide uppercase">
              Ohio Infrastructure
            </span>
          </div>

          <h2 className="text-stone-800 font-black text-4xl leading-tight mb-5">
            Rickenbacker, Ohio
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              ASU Logistics Production Corridor
            </span>
          </h2>

          <p className="text-stone-600 text-base leading-relaxed mb-5">
            SkyForge is developing an Air Separation Unit adjacent to the Rickenbacker logistics hub — one of the Midwest's fastest-growing freight and aviation cargo corridors.
          </p>

          <p className="text-stone-600 text-base leading-relaxed mb-8">
            This facility will serve as a regional supply backbone supporting Ohio's industrial expansion and national logistics distribution networks.
          </p>

          {/* Infrastructure Capabilities */}
          <div className="space-y-3">
            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-xl p-4 hover:shadow-lg transition-all cursor-pointer">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-snowflake-line text-lg text-teal-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Cryogenic Gas Production</p>
                  <p className="text-stone-500 text-xs">High-volume LOX, LIN, and LAR manufacturing</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-xl p-4 hover:shadow-lg transition-all cursor-pointer">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-plane-line text-lg text-cyan-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Air Cargo & Freight Support</p>
                  <p className="text-stone-500 text-xs">Direct logistics hub integration and aviation supply</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-stone-200 rounded-xl p-4 hover:shadow-lg transition-all cursor-pointer">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-stone-200 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-lg text-teal-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Manufacturing Supply Alignment</p>
                  <p className="text-stone-500 text-xs">Regional industrial fabrication and production support</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-stone-200 rounded-xl p-4 hover:shadow-lg transition-all cursor-pointer">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-stone-200 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-star-line text-lg text-cyan-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Defense & Aerospace Demand Support</p>
                  <p className="text-stone-500 text-xs">Strategic supply for aerospace and defense sectors</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-stone-200 rounded-xl p-4 hover:shadow-lg transition-all cursor-pointer">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-stone-200 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-train-line text-lg text-teal-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Rail & Interstate Logistics Connectivity</p>
                  <p className="text-stone-500 text-xs">Multi-modal distribution network integration</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Image */}
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/c86446b8f1f42689f1120c76de5769c7.jpg"
              alt="Rickenbacker Logistics Corridor"
              className="w-full h-[500px] object-cover object-top"
            />
          </div>

          {/* Regional Supply Backbone Badge */}
          <div className="absolute -bottom-6 left-6 right-6 bg-stone-50 border border-stone-200 rounded-2xl p-5 shadow-xl">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-map-pin-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-sm">Regional Supply Backbone</p>
                  <p className="text-stone-500 text-xs">Midwest Industrial Expansion Support</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-2xl font-black">
                  ASU
                </p>
                <p className="text-stone-500 text-xs">Production</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
